import styled, { css } from "styled-components";
import { Colors, Fonts, Scale } from '../../themes';
import { deviceSize } from '../../constants/deviceSize'

export const StyledFilterUser = styled.div`
  margin: 0 30px 0 30px;
`